<template>
    <div class="wrap">
        <div class="body">
            <slot></slot>
        </div>
        <img
            @click="back"
            class="back"
            :src="require('@/assets/img_svg/back.svg')"
            alt="svg"
        />
    </div>
</template>
<script>
export default {
    methods: {
        back: function() {
            this.$router.back();
        },
    },
};
</script>
<style scoped>
.wrap {
    width: 1200px;
    margin: 100px auto;
    box-sizing: border-box;
    padding-right: 240px;
}
.back {
    width: 32px;
    height: 32px;
    cursor: pointer;
}
.body h1,
h2,
h3,
h4,
h5,
h6 {
    font-size: 22px;
    color: #151515;
    line-height: 32px;
    font-weight: bold;
    margin-bottom: 40px;
}
.body p {
    font-size: 18px;
    color: #333333;
    line-height: 32px;
    margin-bottom: 40px;
}
.body img {
    margin-bottom: 40px;
}
.body .indent {
    text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/Pages/CustomerDetail/DetailBody.vue